export const PROJECT_PERMISSIONS = {
    ProjectView: 'project:view',
    ProjectEditDetails: 'project:edit-details',
    ProjectUploadAssets: 'project:upload-assets',
    ProjectApproveAssets: 'project:approve-assets',
    ProjectComment: 'project:comment',
    ProjectDelete: 'project:delete',
    ManageProjectMembers: 'platform:manage-project-members',
    ManageApprovalChains: 'project:manage-approval-chains',
};
